import React, { useCallback, useEffect, useMemo, useState } from "react";

import { FieldDescription } from "./DataAnalysis";
import { transferItem } from "./";
import instance from "../../util/axios";
import Chart from "./DataAnalysis";
import { Popover, Toast } from "antd-mobile-v5";
import { timeSlotChange } from "../EnterpriseWechat/CustomersAndGroups/CustomerBase/component/dataFormat";
import { Action } from "antd-mobile-v5/es/components/popover";
import "./style.css";
import styled from "styled-components";
import { BaseURL } from "../../constant";
interface DesignerProps {
  selectedObject: transferItem[];
  fieldJoins?: { [key: string]: string }[];
  defaultReportData?: ReportDef;
  name: string;
  id: string;
  showReport?: string;
  showStatisticalChart?: string;
  chartHeight?: number | string;
  isApp?: string;
}

const TableWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
  flex: 1;
  height: 330px;
  overflow: hidden;
  padding-left: 10px;
  table {
    width: 100%;
    text-align: left;
    border-radius: 2px 2px 0 0;
    border-spacing: 0;
  }

  td {
    border: 1px solid #f0f0f0;
    padding: 8px 16px;
    position: relative;
    overflow-wrap: break-word;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  tr:nth-child(1) {
    background: #fafafa;
    font-weight: 500;
  }
`;
const actions: Action[] = [
  {
    text: "全部",
    key: "",
  },
  {
    text: "今日",
    key: timeSlotChange("今天")
      .map((item) => item.slice(0, 10))
      .join("~"),
  },
  {
    text: "本周",
    key: timeSlotChange("本周")
      .map((item) => item.slice(0, 10))
      .join("~"),
  },
  {
    text: "本月",
    key: timeSlotChange("本月")
      .map((item) => item.slice(0, 10))
      .join("~"),
  },
  {
    text: "本年",
    key: timeSlotChange("今年")
      .map((item) => item.slice(0, 10))
      .join("~"),
  },
];

export interface ReportDef {
  name: string;
  uuid: string;
  topFields: { [key: string]: any }[];
  leftFields: { [key: string]: any }[];
  aggregateDefs: { [key: string]: any }[];
  objectDefs: { [key: string]: any }[];
  preDefinedFiltersForAggregate: any[];
  preDefinedFiltersForReport: FieldDescription[];
  joins: { [key: string]: any }[];
  filters: { [key: string]: any }[];
  reportFromRow: number;
  sheetContent: { [key: string]: any }[];
  statistiChartType: "bar" | "line" | "pie" | "map";
}

export default function DesignerAnalysis({
  selectedObject = [],
  fieldJoins = [],
  id = "",
  name,
  defaultReportData,
  showReport,
  showStatisticalChart,
  chartHeight,
  isApp,
}: DesignerProps) {
  const [chartType, setChartType] = useState<"bar" | "line" | "pie" | "map">(
    "bar"
  );

  //统计数据
  const [reportForm, setReportForm] = useState<ReportDef>();

  //筛选弹窗的字段
  const [dataSource, setDataSource] = useState<FieldDescription[]>([]);

  //统计图数据
  const [chartDataSource, setChartDataSource] = useState<any>();

  let conut = 1;

  //表格数据
  const [rows, setRows] = useState<any>();
  const [realRows, setRealRows] = useState<any>();

  //时间筛选数据
  const [nodeData, setNodeData] = useState<any>({
    text: "全部",
    key: "",
    viseable: false,
    data: [],
  });
  //通过上一步选择的表名,查询所有字段
  useEffect(() => {
    (async () => {
      if (selectedObject.length > 0) {
        const fields = [];
        for (let i = 0; i < selectedObject.length; i++) {
          const resp = await instance.post(
            BaseURL +
              "/crm/systemConfig/fieldDescription/getFieldDescriptionList",
            {
              tableName: selectedObject[i].tableName,
            }
          );
          if (resp.data.Status === "1") {
            fields.push(
              ...resp.data.Data.map((item: any) => {
                return {
                  ...item,
                  dictionary:
                    item.inputType === 4 ? item.fieldName : item.dictionary,
                };
              })
            );
          }
        }
        setDataSource(fields);
      }
    })();
  }, [selectedObject]);

  useEffect(() => {
    if (dataSource.length > 0) {
      if (defaultReportData && JSON.stringify(defaultReportData) !== "{}") {
        defaultReportData.aggregateDefs &&
          defaultReportData.aggregateDefs.length > 0 &&
          defaultReportData.aggregateDefs.forEach((item: any, i: number) => {
            if (
              defaultReportData.preDefinedFiltersForAggregate[i] &&
              defaultReportData.preDefinedFiltersForAggregate[i].length > 0
            ) {
              item.hasPreDefinedFilters = true;
            }
          });
        setChartType(defaultReportData.statistiChartType);
        fill(
          defaultReportData,
          undefined,
          defaultReportData.preDefinedFiltersForAggregate,
          defaultReportData.preDefinedFiltersForReport,
          [],
          defaultReportData.reportFromRow
        );
      }
    }
  }, [dataSource.length, defaultReportData]);

  const fill = useCallback(
    async (
      reportData,
      type = "",
      aggFilter = [],
      preDefinedFiltersForReport = [],
      reportFilters = [],
      fromRow?: number
    ) => {
      if (type === "aggregate_delete") return;
      if (type === "filter") return;
      reportData.objectDefs = selectedObject;
      reportData.joins = fieldJoins;
      reportData.chartSort = 2;
      reportData.aggregateDefs = reportData.aggregateDefs.map((item: any) => ({
        ...item,
        aggregateType: item.aggregateType || "sum",
      }));
      reportData.preDefinedFiltersForReport =
        preDefinedFiltersForReport.length > 0
          ? preDefinedFiltersForReport.map((item: { fieldName: string }) => ({
              ...item,
              fieldNames: item.fieldName,
            }))
          : []; //默认报表的预定义筛选条件
      const newAggFilter: (any[] | null)[] = [];
      aggFilter.forEach((agg: any[]) => {
        if (agg && agg.length > 0) {
          newAggFilter.push(
            agg.map((aggItem) => ({
              ...aggItem,
              fieldNames: aggItem.fieldName,
            }))
          );
        } else {
          newAggFilter.push(null);
        }
      });
      reportData.preDefinedFiltersForAggregate = newAggFilter;

      setReportForm(reportData);
      const copyReportData = JSON.parse(JSON.stringify(reportData));
      delete copyReportData.sheetContent;
      if (reportFilters.length > 0) {
        copyReportData.filters = reportFilters.map(
          (item: { fieldName: string }) => ({
            ...item,
            fieldNames: item.fieldName,
          })
        );
      }
      if (
        copyReportData &&
        copyReportData.filters &&
        copyReportData.filters.length > 0
      ) {
        let flag = true;
        for (let i = 0; i < copyReportData.filters.length; i++) {
          if (copyReportData.filters[i].filterType === "date" && flag) {
            setNodeData((prevState: any) => ({
              ...prevState,
              visiable: true,
            }));
            flag = false;
          }
        }
        setNodeData((prevState: any) => ({
          ...prevState,
          data: copyReportData.filters,
          visiable: true,
        }));
      }
      const resp = await instance.post(BaseURL + "/chart/report/fill", {
        reportDef: JSON.stringify(copyReportData),
      });
      if (resp.data.Status !== "1") return;
      const dicts = resp.data.Data.dicts;
      const datas = resp.data.Data.data;
      reportData.topFields.forEach(
        (topField: { dictionary: string; dict: any[] }) => {
          for (const i in dicts) {
            if (i === topField.dictionary) {
              topField.dict = dicts[i].map((item: { name: string }) => ({
                ...item,
                value: item.name,
              }));
            }
          }
        }
      );
      if (defaultReportData && defaultReportData.statistiChartType === "map") {
        dicts.省.forEach((item: any) => {
          if (item.name === "新疆维吾尔自治区") {
            item.name = "新疆省";
          }
          if (item.name === "西藏自治区") {
            item.name = "西藏省";
          }
          if (item.name === "内蒙古自治区") {
            item.name = "内蒙古省";
          }
          if (item.name === "广西壮族自治区") {
            item.name = "广西省";
          }
          if (item.name === "宁夏回族自治区") {
            item.name = "宁夏省";
          }
          if (item.name === "香港特别行政区") {
            item.name = "香港省";
          }
          if (item.name === "澳门特别行政区") {
            item.name = "澳门省";
          }
        });
      }

      //生成图表数据
      const data_extra = resp.data.Data.data_extra;
      if (
        (reportData.topFields.length === 1 ||
          reportData.leftFields.length === 1) &&
        reportData.aggregateDefs.length > 0
      ) {
        const chartData = [...datas];
        if (data_extra && JSON.stringify(data_extra) !== "{}") {
          for (const de in data_extra) {
            chartData.push(
              ...data_extra[de].map((dataExtraItem: any) => ({
                ...dataExtraItem,
                index: parseInt(de),
              }))
            );
          }
        }
        if (
          ((reportData?.topFields.length === 1 &&
            reportData?.leftFields.length === 0) ||
            (reportData?.leftFields.length === 1 &&
              reportData?.topFields.length === 0)) &&
          reportData?.aggregateDefs.length > 0
        ) {
          setChartDataSource({
            data: chartData,
            dicts: dicts,
            aggFields: reportData.aggregateDefs.map(
              (agg: { fieldName: string }, ai: number) => {
                if (
                  reportData.preDefinedFiltersForAggregate[ai] &&
                  reportData.preDefinedFiltersForAggregate[ai].length > 0
                ) {
                  return agg.fieldName + ai;
                }
                return agg.fieldName;
              }
            ),
            titles: reportData.aggregateDefs.map(
              (agg: {
                fieldName: string;
                title: string;
                fieldShowName: string;
              }) => agg.title || agg.fieldShowName || agg.fieldName
            ),
          });
        } else {
          setChartDataSource(null);
        }
      }
      //报表图表数据
      reportData.leftFields.forEach(
        (leftField: { dictionary: string; dict: any[] }) => {
          for (const i in dicts) {
            if (i === leftField.dictionary) {
              leftField.dict = dicts[i].map((item: { name: string }) => ({
                ...item,
                value: item.name,
              }));
            }
          }
        }
      );

      const topFields: any[] = reportData.topFields;
      const leftFields: any[] = reportData.leftFields;
      const aggFields: any[] = reportData.aggregateDefs;
      const rows: any[] = [];
      //如果字段区大于等于两个字段时
      if (
        aggFields.length >= 2 ||
        (aggFields.length === 1 && topFields.length === 0) ||
        (aggFields.length === 1 && leftFields.length === 0)
      ) {
        if (leftFields.length === 0) {
          topFields.forEach((item) => {
            const cellObj: any = {
              cells: [
                {
                  value: "",
                },
              ],
            };
            rows.push(cellObj);
          });
        } else {
          const cellObj: any = {
            cells: [],
          };
          leftFields.forEach(() => {
            cellObj.cells.push({
              value: "",
            });
          });
          rows.push(cellObj);
        }
      } else {
        topFields.forEach(() => {
          const cellObj: any = {
            cells: [],
          };
          leftFields.forEach(() => {
            cellObj.cells.push({
              value: "",
            });
          });
          rows.push(cellObj);
        });
      }
      const data: any[] = datas || [];

      const leftlens =
        leftFields.length > 0
          ? leftFields.map((item: { dict: string | any[] }) => item.dict.length)
          : [];

      leftFields.length > 0 &&
        leftFields.forEach(
          (
            lf: {
              dict: any[];
            },
            index: number
          ) => {
            const leftlensNotSelf = leftlens.filter((item, i) => i > index);

            for (
              let a = 0;
              a < (index === 0 ? 1 : leftFields[index - 1].dict.length);
              a++
            ) {
              lf.dict.forEach((element, i) => {
                const rowSpan =
                  leftlensNotSelf.length > 1
                    ? leftlensNotSelf.reduce((x, y) => x * y)
                    : leftlensNotSelf.length === 1
                    ? leftlensNotSelf[0]
                    : 1;

                const obj: any = {
                  cells: [
                    {
                      value: element.value,
                      rowSpan: rowSpan,
                    },
                  ],
                };
                if (index === 0 && a === 0) {
                  rows.push(obj);
                  if (rowSpan > 1) {
                    for (let b = 0; b < rowSpan - 1; b++) {
                      rows.push({
                        cells: [
                          {
                            value: "",
                            rowSpan: 1,
                            style: null,
                          },
                        ],
                      });
                    }
                  }
                }
                if (index !== 0) {
                  const curr =
                    aggFields.length >= 2 ||
                    (aggFields.length === 1 && topFields.length === 0)
                      ? i + 1
                      : topFields.length + i;
                  rows[curr + a * lf.dict.length].cells.push({
                    value: element.value,
                    rowSpan: rowSpan,
                  });
                  if (rowSpan > 1) {
                    for (let b = 0; b < rowSpan - 1; b++) {
                      rows[curr + a * lf.dict.length].cells.push({
                        value: "",
                        rowSpan: 1,
                      });
                    }
                  }
                }
              });
            }
          }
        );

      const toplens =
        topFields && topFields?.length > 0
          ? topFields.map((item) => item.dict?.length)
          : [];

      //如果字段区大于等于两个字段时
      if (
        aggFields.length >= 2 ||
        (aggFields.length === 1 && topFields.length === 0) ||
        (aggFields.length === 1 && leftFields.length === 0)
      ) {
        if (leftFields.length === 0) {
          aggFields.forEach((agg, index) => {
            const cells = {
              cells: [
                {
                  value: agg.title || agg.fieldShowName || agg.fieldName,
                },
              ],
            };
            rows.push(cells);
          });
          topFields.length > 0 &&
            topFields.forEach((tf, index) => {
              const toplensNotSelf = toplens.filter((item, i) => i > index);

              for (
                let a = 0;
                a < (index === 0 ? 1 : topFields[index - 1].dict.length);
                a++
              ) {
                tf.dict?.forEach((element: { name: any; uuid: any }) => {
                  const colSpan =
                    toplensNotSelf.length > 1
                      ? toplensNotSelf.reduce((x, y) => x * y)
                      : toplensNotSelf.length === 1
                      ? toplensNotSelf[0]
                      : 1;
                  rows[index].cells.push({
                    value: element.name,
                    fieldName: tf.fieldName,
                    fieldValue: element.uuid,
                    colSpan: colSpan,
                  });
                  if (colSpan > 1) {
                    for (let b = 0; b < colSpan - 1; b++) {
                      rows[index].cells.push({
                        value: "",
                      });
                    }
                  }
                });
              }
            });
        } else {
          aggFields.forEach((agg, index) => {
            rows[0].cells.push({
              value: agg.title || agg.fieldShowName || agg.fieldName,
            });
          });
        }
      } else {
        topFields.length > 0 &&
          topFields.forEach((tf, index) => {
            const toplensNotSelf = toplens.filter((item, i) => i > index);

            for (
              let a = 0;
              a < (index === 0 ? 1 : topFields[index - 1].dict.length);
              a++
            ) {
              tf.dict.forEach((element: { name: any; uuid: any }) => {
                const colSpan =
                  toplensNotSelf.length > 1
                    ? toplensNotSelf.reduce((x, y) => x * y)
                    : toplensNotSelf.length === 1
                    ? toplensNotSelf[0]
                    : 1;
                rows[index].cells.push({
                  value: element.name,
                  fieldName: tf.fieldName,
                  fieldValue: element.uuid,
                  colSpan: colSpan,
                });
                if (colSpan > 1) {
                  for (let b = 0; b < colSpan - 1; b++) {
                    rows[index].cells.push({
                      value: "",
                    });
                  }
                }
              });
            }
          });
      }

      //没有预定义条件的字段&&统计区域字段小于两个
      data.length > 0 &&
        data.forEach((dataItem: any, index) => {
          let t = 0;
          let l = 0;

          for (const i in dataItem) {
            if (topFields.some((t) => t.fieldName === i)) {
              const indx = topFields.findIndex((t) => t.fieldName === i);
              const dictIndex = topFields
                .find((t) => t.fieldName === i)!
                .dict?.findIndex(
                  (item: { uuid: string }) => item.uuid === dataItem[i]
                );
              if (dictIndex === -1) return;
              const toplensNotSelf = toplens.filter((item, ti) => ti > indx);
              t +=
                toplensNotSelf.length > 1
                  ? toplensNotSelf.reduce((x, y) => x * y) * dictIndex
                  : toplensNotSelf.length === 1
                  ? toplensNotSelf[0] * dictIndex
                  : dictIndex;
            }

            if (leftFields.some((l) => l.fieldName === i)) {
              const indx = leftFields.findIndex((l) => l.fieldName === i);
              const dictIndex = leftFields
                .find((l) => l.fieldName === i)!
                .dict.findIndex(
                  (item: { uuid: string }) => item.uuid === dataItem[i]
                );
              if (dictIndex === -1) return;
              const leftlensNotSelf = leftlens.filter((item, li) => li > indx);
              l +=
                leftlensNotSelf.length > 1
                  ? leftlensNotSelf.reduce((x, y) => x * y) * dictIndex
                  : leftlensNotSelf.length === 1
                  ? leftlensNotSelf[0] * dictIndex
                  : dictIndex;
            }
          }
          if (leftFields.length === 0) {
            t += 1;
          } else {
            t += leftFields.length;
          }
          if (
            aggFields.length >= 2 ||
            (aggFields.length === 1 && topFields.length === 0) ||
            (aggFields.length === 1 && leftFields.length === 0)
          ) {
            if (leftFields.length === 0) {
              l += topFields.length;
            } else {
              l += 1;
            }
          } else {
            l += topFields.length;
          }
          if (
            aggFields.length >= 2 ||
            (aggFields.length === 1 && topFields.length === 0) ||
            (aggFields.length === 1 && leftFields.length === 0)
          ) {
            if (leftFields.length === 0) {
              aggFields.forEach((agg, j) => {
                rows[l + j].cells[t] = {
                  value: dataItem[aggFields[j].fieldName],
                };
              });
            } else {
              aggFields.forEach((agg, j) => {
                rows[l].cells[leftFields.length + j] = {
                  value: dataItem[aggFields[j].fieldName],
                };
              });
            }
          } else {
            if (rows[l] && rows[l].cells) {
              rows[l].cells[t] = {
                value: dataItem[reportData.aggregateDefs[0].fieldName],
              };
            }
          }
        });

      //有预定义条件的字段&&统计区域字段大于等于两个
      if (data_extra && JSON.stringify(data_extra) !== "{}") {
        for (const b in data_extra) {
          rows.forEach((row, ri) => {
            const ts = leftFields.length === 0 ? topFields.length : 0;

            if (leftFields.length === 0) {
              if (ri === ts + parseInt(b)) {
                rows[ts + parseInt(b)].cells &&
                  rows[ts + parseInt(b)].cells.length > 0 &&
                  rows[ts + parseInt(b)].cells.forEach(
                    (row: { value: string }, cellIndex: number) => {
                      if (cellIndex > 0) {
                        row.value = "";
                      }
                    }
                  );
              }
            } else {
              if (ri > ts) {
                const ls = leftFields.length + parseInt(b);
                if (
                  rows[ri] &&
                  rows[ri].cells &&
                  rows[ri].cells[ls] &&
                  rows[ri].cells[ls].value
                )
                  rows[ri].cells[ls].value = "";
              }
            }
          });
          if (
            aggFields.length >= 2 ||
            (aggFields.length === 1 && topFields.length === 0) ||
            (aggFields.length === 1 && leftFields.length === 0)
          ) {
            if (leftFields.length === 0) {
              data_extra[b].forEach((dataItem: { [x: string]: string }) => {
                let t = 0;
                for (const i in dataItem) {
                  if (topFields.some((t) => t.fieldName === i)) {
                    const indx = topFields.findIndex((l) => l.fieldName === i);
                    const dictIndex = topFields
                      .find((l) => l.fieldName === i)!
                      .dict.findIndex(
                        (item: { uuid: string }) => item.uuid === dataItem[i]
                      );
                    if (dictIndex === -1) return;
                    const toplensNotSelf = toplens.filter(
                      (item, li) => li > indx
                    );
                    t +=
                      toplensNotSelf.length > 1
                        ? toplensNotSelf.reduce((x, y) => x * y) * dictIndex
                        : toplensNotSelf.length === 1
                        ? toplensNotSelf[0] * dictIndex
                        : dictIndex;
                  }
                }
                t += 1;
                const l = topFields.length + parseInt(b);
                rows[l].cells[t] = {
                  value: dataItem[aggFields[parseInt(b)].fieldName],
                };
              });
            } else {
              data_extra[b].forEach((dataItem: { [x: string]: string }) => {
                let l = 0;
                for (const i in dataItem) {
                  if (leftFields.some((l) => l.fieldName === i)) {
                    const indx = leftFields.findIndex((l) => l.fieldName === i);
                    const dictIndex = leftFields
                      .find((l) => l.fieldName === i)!
                      .dict.findIndex(
                        (item: { uuid: string }) => item.uuid === dataItem[i]
                      );
                    if (dictIndex === -1) return;
                    const leftlensNotSelf = leftlens.filter(
                      (item, li) => li > indx
                    );
                    l +=
                      leftlensNotSelf.length > 1
                        ? leftlensNotSelf.reduce((x, y) => x * y) * dictIndex
                        : leftlensNotSelf.length === 1
                        ? leftlensNotSelf[0] * dictIndex
                        : dictIndex;
                  }
                }
                l += 1;
                const t = leftFields.length + parseInt(b);
                rows[l].cells[t] = {
                  value: dataItem[aggFields[parseInt(b)].fieldName],
                };
              });
            }
          }
        }
      }
      setRows(rows);
      setRealRows(rows);
    },
    [fieldJoins, selectedObject]
  );
  console.log(realRows, "realRows");
  console.log(rows, "rows");
  return (
    <>
      {chartDataSource && (
        <>
          <div
            style={{
              borderBottom: "1px solid #f3f3f3",
              fontWeight: 600,
              fontSize: 16,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                borderLeft: "4px solid rgb(39, 99, 251)",
                paddingLeft: "10px",
              }}
            >
              {name}
            </div>
            {nodeData.visiable && (
              <Popover.Menu
                className="popovermenu"
                actions={actions}
                onAction={(node) => {
                  Toast.show(`选择了 ${node.text}`);
                  if (
                    defaultReportData &&
                    JSON.stringify(defaultReportData) !== "{}"
                  ) {
                    let arr = nodeData.data;
                    let flag = true;
                    for (let i = 0; i < arr.length; i++) {
                      if (arr[i].filterType === "date" && flag) {
                        arr[i].valueText = node.key;
                        flag = false;
                      }
                    }
                    fill(
                      defaultReportData,
                      undefined,
                      defaultReportData.preDefinedFiltersForAggregate,
                      defaultReportData.preDefinedFiltersForReport,
                      arr,
                      defaultReportData.reportFromRow
                    );

                    setNodeData((prevState: any) => ({
                      ...prevState,
                      text: node.text,
                    }));
                  }
                }}
                placement="bottom-start"
                trigger="click"
              >
                <div style={{ fontWeight: 400, fontSize: 14 }}>
                  {nodeData.text}
                </div>
              </Popover.Menu>
            )}
          </div>
          <div style={{ padding: 8, paddingTop: 0 }}>
            <Chart
              key={chartType}
              dataSource={chartDataSource}
              chartType={chartType}
              description={dataSource}
              height={chartHeight}
              isApp={isApp}
            />
          </div>

          <div
            style={{
              borderBottom: "1px solid #f3f3f3",
              fontWeight: 600,
              fontSize: 16,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                borderLeft: "4px solid rgb(39, 99, 251)",
                paddingLeft: "10px",
              }}
            >
              详细数据
            </div>
          </div>
          <div>
            {rows && rows.length > 0 && (
              <TableWrapper style={{ overflow: "auto" }}>
                <div>
                  <table>
                    <tbody>
                      {realRows &&
                        realRows[1].cells &&
                        realRows[1].cells.length > 0 &&
                        realRows[1].cells.map((row: any, index: number) => {
                          return (
                            <tr key={`tr${index}`}>
                              {index === 0 ? (
                                <td style={{ cursor: "pointer" }}>排名</td>
                              ) : (
                                <td
                                  style={{ cursor: "pointer" }}
                                  key={`td${index}`}
                                >
                                  {" "}
                                  {conut++}
                                </td>
                              )}
                              {realRows.map((item: any, cellIndex: number) => {
                                if (cellIndex === realRows.length - 1) {
                                  return (
                                    <>
                                      <td
                                        style={{ cursor: "pointer" }}
                                        key={`td${cellIndex}`}
                                      >
                                        {" "}
                                        {item.cells[index]?.value}
                                      </td>
                                      {index === 0 ? (
                                        <td style={{ cursor: "pointer" }}>
                                          占比
                                        </td>
                                      ) : (
                                        <td style={{ cursor: "pointer" }}>
                                          {(
                                            (item.cells[index]?.value /
                                              item.cells
                                                .map(
                                                  (item1: any, index: number) =>
                                                    index == 0
                                                      ? 0
                                                      : item1.value
                                                      ? item1.value
                                                      : 0
                                                )
                                                .reduce(
                                                  (a: number, b: number) =>
                                                    a + b
                                                )) *
                                            100
                                          ).toFixed(2)}
                                          %
                                        </td>
                                      )}
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      {index === 0 ? (
                                        <td style={{ cursor: "pointer" }}>
                                          图例
                                        </td>
                                      ) : (
                                        <td
                                          style={{ cursor: "pointer" }}
                                          key={`td${cellIndex}`}
                                        >
                                          {item.cells[index]?.value}
                                        </td>
                                      )}
                                    </>
                                  );
                                }
                              })}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </TableWrapper>
            )}
          </div>
        </>
      )}
    </>
  );
}
